<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-snackbar
    v-model="isOpen"
    :timeout="-1"
    top
    right
    class="notification-layout"
    @mouseover="handleNotificationHover"
    @mouseleave="handleNotificationLeave"
    @focusin="handleNotificationHover"
    @focusout="handleNotificationLeave"
  >
    <div>
      <v-btn
        text
        fab
        class="notification-close-btn"
        x-small
        @click="closeNotification"
      >
        <v-icon small>
          mdi-close-circle
        </v-icon>
      </v-btn>
      <v-flex>
        <v-row no-gutters class="align-center">
          <v-col cols="auto">
            <v-icon v-if="type === 'success'" class="success-icon">
              mdi-checkbox-marked-circle
            </v-icon>
            <v-icon v-if="type === 'warning'" class="warning-icon">
              mdi-alert
            </v-icon>
            <v-icon v-if="type === 'error'" class="error-icon">
              mdi-close-circle
            </v-icon>
            <div v-if="type === 'loading'" class="loading-icon">
              <v-progress-circular
                indeterminate
                class="p-4"
                color="white"
              />
            </div>
          </v-col>
          <v-col cols="auto">
            <div class="notification--header">
              {{ capitalize(props.content) }}
            </div>
            <div
              v-if="props.linkText"
              class="notification--link-text"
            >
              {{ props.linkText }}
              <br>
              <a :href="link">
                {{ props.linkLabel }}
              </a>
            </div>
          </v-col>
        </v-row>
      </v-flex>
    </div>
  </v-snackbar>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import './styles/notification.scss';

const props = defineProps({
  content: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: ''
  },
  linkText: {
    type: String,
    default: ''
  },
  linkLabel: {
    type: String,
    default: ''
  },
  link: {
    type: String,
    default: ''
  },
  isNotificationOpen: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['notificationClosed']);

const isOpen = ref(false); // TODO: If Vue 3.4 or above, to be replaced by defineModels

const notificationTimeoutDuration = ref(8000);

let notificationTimeout = setTimeout(() => { isOpen.value = false; }, notificationTimeoutDuration.value);

const capitalize = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1);

function handleNotificationHover() {
  clearTimeout(notificationTimeout);
}

function handleNotificationLeave() {
  notificationTimeout = setTimeout(() => {
    isOpen.value = false;
  }, notificationTimeoutDuration.value);
}

function closeNotification() {
  clearTimeout(notificationTimeout);
  isOpen.value = false;
}

watch(
  () => props.isNotificationOpen,
  () => {
    clearTimeout(notificationTimeout);
    isOpen.value = props.isNotificationOpen;
    notificationTimeout = setTimeout(() => {
      isOpen.value = false;
    }, notificationTimeoutDuration.value);
  }
);

watch(
  isOpen,
  () => {
    if (!isOpen.value) {
      emit('notificationClosed');
    }
  }
);
</script>
